var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"json-editor scroll-vertical"},[(_vm.jsonText)?_c('text-editor',{staticClass:"editor",attrs:{"text":_vm.jsonText,"lineNumbers":true},on:{"update:textUpdate":function($event){_vm.config = $event}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }